"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OthelloGame = exports.getCurrentPlayer = exports.diskToPlayer = exports.playerToDisk = void 0;
var logic_1 = require("@othello/logic");
var playerToDisk = function (player) {
    switch (player) {
        case '0': return logic_1.Disk.BLACK;
        case '1': return logic_1.Disk.WHITE;
        default: throw new Error('Unexpected player ID: ' + player);
    }
};
exports.playerToDisk = playerToDisk;
var diskToPlayer = function (disk) { return (String(disk)); };
exports.diskToPlayer = diskToPlayer;
var getCurrentPlayer = function (ctx) { return (exports.playerToDisk(ctx.currentPlayer)); };
exports.getCurrentPlayer = getCurrentPlayer;
exports.OthelloGame = {
    setup: function () {
        var board = logic_1.createBoard();
        logic_1.initializeBoard(board);
        return {
            board: board,
            lastPlaced: null,
        };
    },
    turn: {
        moveLimit: 1,
        order: {
            first: function (_G, _ctx) { return 0; },
            /**
             * Called at the end of a player's turn.
             * E.g. called after player 0 plays their first move and
             * `ctx.playOrderPos` will be 0.
             */
            next: function (G, ctx) {
                var currPos = ctx.playOrderPos;
                var nextPos = (currPos + 1) % ctx.numPlayers;
                var nextPlayer = ctx.playOrder[nextPos];
                var nextDisk = exports.playerToDisk(nextPlayer);
                return logic_1.hasLegalMoves(G.board, nextDisk) ? nextPos : currPos;
            },
        },
    },
    moves: {
        clickCell: function (G, ctx, index) {
            var board = G.board;
            var disk = exports.getCurrentPlayer(ctx);
            if (!logic_1.isLegalMoveForIndex(board, index, disk)) {
                // TODO: Replace with `INVALID_MOVE` constant when not using Codesandbox
                return 'INVALID_MOVE';
            }
            var clone = board.slice(0);
            var moves = logic_1.playMoveAtIndex(clone, index, disk);
            logic_1.applyMoves(clone, moves);
            return {
                board: clone,
                lastPlaced: index,
            };
        },
    },
    endIf: function (G, _ctx) {
        var board = G.board;
        if (!logic_1.isGameOver(board))
            return;
        var winner = logic_1.getWinner(board);
        if (winner === null)
            return { draw: true };
        return { winner: exports.diskToPlayer(winner) };
    },
    ai: {
        enumerate: function (G, ctx) {
            var board = G.board;
            var disk = exports.getCurrentPlayer(ctx);
            return logic_1.getLegalMoveIndexesForPlayer(board, disk)
                .map(function (i) { return ({
                move: 'clickCell',
                args: [i],
            }); });
        },
    },
};
